import type { DeviceType } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const TRAFFIC_AND_ENGAGEMENT_ENDPOINTS = {
    [devicesTypes.DESKTOP]: {
        data: "widgetApi/TrafficAndEngagement/SegmentEngagement/Desktop/Data",
        excel: "widgetApi/TrafficAndEngagement/SegmentEngagement/Desktop/Excel",
    },
    [devicesTypes.MOBILE]: {
        data: "widgetApi/TrafficAndEngagement/SegmentEngagement/MobileWeb/Data",
        excel: "widgetApi/TrafficAndEngagement/SegmentEngagement/MobileWeb/Excel",
    },
    [devicesTypes.TOTAL]: {
        data: "widgetApi/TrafficAndEngagement/SegmentEngagement/Total/Data",
        excel: "widgetApi/TrafficAndEngagement/SegmentEngagement/Total/Excel",
    },
} satisfies Record<DeviceType, { data: string; excel: string }>;
